import { useState, useEffect } from 'react';

export default function Hero() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 50;
      setIsScrolled(scrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      <img
        src="https://static.readdy.ai/image/ddc6a6c51837b652ebd36d1bdad447b7/434f0df87548a5aa61b4bcebbf092c53.jpeg"
        alt="Vaciado de pisos en Barcelona"
        className="absolute inset-0 w-full h-full object-cover object-center"
        fetchpriority="high"
        width="1920"
        height="1080"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
        <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight px-2">
          Vaciado de pisos en Barcelona
        </h1>
        <p className="text-lg sm:text-xl md:text-2xl text-white/95 mb-6 sm:mb-8 max-w-3xl mx-auto leading-relaxed px-2">
          Servicio profesional, rápido y sin complicaciones. Nos encargamos de todo para que tú no tengas que preocuparte.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 px-4">
          <a
            href="tel:629501941"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-3 bg-teal-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line text-lg sm:text-xl"></i>
            Llámanos: 629 501 941
          </a>
          <button
            onClick={() => {
              const element = document.getElementById('contacto');
              element?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-3 bg-white text-teal-600 px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-gray-50 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            <i className="ri-file-list-3-line text-lg sm:text-xl"></i>
            Presupuesto Gratis
          </button>
        </div>

        <div className="mt-12 sm:mt-16 grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-8 max-w-4xl mx-auto px-2">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 sm:p-6 border border-white/20">
            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-600 rounded-lg flex items-center justify-center mx-auto mb-3 sm:mb-4">
              <i className="ri-time-line text-xl sm:text-2xl text-white"></i>
            </div>
            <h3 className="text-base sm:text-lg font-semibold text-white mb-1 sm:mb-2">Servicio Rápido</h3>
            <p className="text-xs sm:text-sm text-white/90">Vaciamos tu piso en 24-48 horas</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 sm:p-6 border border-white/20">
            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-600 rounded-lg flex items-center justify-center mx-auto mb-3 sm:mb-4">
              <i className="ri-shield-check-line text-xl sm:text-2xl text-white"></i>
            </div>
            <h3 className="text-base sm:text-lg font-semibold text-white mb-1 sm:mb-2">Totalmente Asegurado</h3>
            <p className="text-xs sm:text-sm text-white/90">Trabajamos con todas las garantías</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 sm:p-6 border border-white/20">
            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-600 rounded-lg flex items-center justify-center mx-auto mb-3 sm:mb-4">
              <i className="ri-money-euro-circle-line text-xl sm:text-2xl text-white"></i>
            </div>
            <h3 className="text-base sm:text-lg font-semibold text-white mb-1 sm:mb-2">Precio Transparente</h3>
            <p className="text-xs sm:text-sm text-white/90">Sin sorpresas ni costes ocultos</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <button
          onClick={() => {
            const element = document.getElementById('servicios');
            element?.scrollIntoView({ behavior: 'smooth' });
          }}
          className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center hover:bg-white/30 transition-colors cursor-pointer"
          aria-label="Scroll down"
        >
          <i className="ri-arrow-down-line text-2xl text-white"></i>
        </button>
      </div>
    </section>
  );
}
